import { useState } from "react";

/**
 * Renders a logo image, or a dashed "LOGO" placeholder when no src is
 * supplied (or the image fails to load) so layout never breaks.
 */
export default function LogoSlot({
  src,
  alt = "Logo",
  className = "",
  placeholderClassName = "",
}) {
  const [failed, setFailed] = useState(false);

  if (src && !failed) {
    return (
      <img
        src={src}
        alt={alt}
        className={className}
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <div
      role="img"
      aria-label={alt}
      className={`flex items-center justify-center rounded-lg border-2 border-dashed border-current/30 font-heading text-[0.65rem] font-bold tracking-widest text-current/50 ${className} ${placeholderClassName}`}
    >
      LOGO
    </div>
  );
}
